import React from "react";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/gckqm0ag_IMG-20240809-WA0005.jpg";

export default function Hero() {
  return (
    <section id="top" className="relative h-[100svh] min-h-[640px] w-full overflow-hidden" data-testid="hero-section">
      <img
        src={HERO_IMG}
        alt="Velero clásico Zorba navegando"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 h-full container-tight flex flex-col justify-end pb-20 md:pb-28">
        <div className="max-w-3xl text-white fade-in-up">
          <p className="label-eyebrow text-white/80 mb-5" data-testid="hero-eyebrow">
            Velero clásico · Portonovo · Rías Baixas
          </p>
          <h1
            className="font-heading text-5xl md:text-7xl leading-[1.05] tracking-tight"
            data-testid="hero-title"
          >
            50 años de mar, madera y memoria.
          </h1>
          <p
            className="mt-6 text-lg md:text-xl text-white/85 max-w-2xl leading-relaxed"
            data-testid="hero-subtitle"
          >
            Un velero clásico de madera en las Rías Baixas para vivir el mar de otra manera: con calma, historia y la intimidad de una salida privada.
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-2" data-testid="hero-chips">
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-white/90">
              🐾 Dog friendly
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-white/90">
              Privado · hasta 12 pax + tripulación
            </span>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contacto"
              data-testid="hero-whatsapp-btn"
              className="btn-pill bg-white text-navy hover:bg-cream px-7 py-3.5 text-sm md:text-base font-medium inline-flex items-center gap-2 shadow-lg"
            >
              Solicitar información
              <ArrowRight size={18} />
            </a>
            <a
              href="#experiencias"
              data-testid="hero-explore-btn"
              className="btn-pill border border-white/40 text-white hover:bg-white/10 px-7 py-3.5 text-sm md:text-base font-medium"
            >
              Ver experiencias
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 hidden md:block z-10 text-white/70 text-xs tracking-widest uppercase rotate-90 origin-bottom-right">
        S/V Zorba
      </div>
    </section>
  );
}
